<script>
  import Link from '../../utils/link.html';
  import Menu from '../../components/navigation/menu';
  import Archive from '../../components/buttons/trash';
  import Plus from '../../components/buttons/plus';
  import Loader from '../../components/ui/loader.html';
  import { onMount, afterUpdate, getContext } from "svelte";
  import { gql } from "apollo-boost";
  import {addNotification, ICONS} from '../../utils/notifications.store';
  import {UPDATE_COORDINATOR, ADD_COORDINATOR} from '../../graphql/coordinators';

  import {COORDINATOR} from '../../graphql/coordinators';

  import CoordinatorGeneral from './components/sections/coordinator.general';


  const client = getContext('apollo');
  const history = getContext('history');

   const components = {
    'general': CoordinatorGeneral,
  }

  export let match = {};
  let loading = true;
  let coordinator;
  let error;
  $: current = components[match.params.section] || components['general'];
 

  const menu = [
    {id:'general', label: 'Coordinator Details', link:`/coordinators/view/${match.params.id}`},
  ]

  async function getCoordinator() {
    try {
      const { data } = await client.query({
        query: COORDINATOR,
        variables: { id: match.params.id }
      });

      coordinator = data.coordinator;
      loading = false;
    } catch (e) {
      loading = false;
      error = e;
    }
  }

  onMount(getCoordinator);

  async function commitArchive() {
    try {
      await client.mutate({mutation: UPDATE_COORDINATOR, variables: {input: {
        id: coordinator.id,
        archived: true
      }}})

      addNotification({
        message:`Archived ${coordinator.firstName}`, 
        icon: ICONS.SUCCESS,
        time: 3000
      })

      history.push('/coordinators');

    } catch (e) {
      
    }
  }

  function archive() {
    addNotification({
      message:`Are you sure you want to archive ${coordinator.firstName}? They will no longer show up in the admin, but will remain assigned to existing programs and events.`, 
      icon: ICONS.CONFIRM,
      confirm: commitArchive
    })
  }
</script>

{#if loading}
  <Loader />
{/if}

{#if !loading}
  <div class="grid-x grid-margin-x">
    <div class="cell small-12 medium-6">
      <h1>{coordinator.firstName} {coordinator.lastName}</h1>
    </div>
    <div class="cell small-12 medium-6 text-right">
      <Archive on:click={archive} label={'ARCHIVE COORDINATOR'} />
    </div>
  </div>
  <div class="grid-x grid-margin-x">
    <div class="cell small-12 medium-12">
      <!--<Menu active={match.params.section || 'general'} items={menu} />-->
    </div>
  </div>

  <svelte:component this={current} bind:value={coordinator} id={match.params.id} />
{/if}

